function buildUpdatedOptionDraft(
  options = [],
  optionIndex,
  field,
  nextValue
) {
  return (Array.isArray(options) ? options : []).map((option, index) => {
    if (index !== optionIndex) {
      return option
    }

    return {
      ...option,
      [field]: nextValue,
    }
  })
}

export { buildUpdatedOptionDraft }
